/*
Copyright (c) 2022 COUNTRYSIDE STOVE & CHIMNEY, INC. - ALL RIGHTS RESERVED

UNAUTHORIZED COPYING, MODIFICATION, OR DISTRIBUTION OF THIS SOFTWARE AND ASSOCIATED DOCUMENTATION FILES ("THE SOFTWARE"),
IN ANY MEDIUM IS STRICTLY PROHIBITED
PROPRIETARY AND CONFIDENTIAL
WRITTEN BY BRANDON SULLIVAN <info@empiredistributing.net>, March 2022
*/

import React, { useState, useRef } from 'react'
import {Platform, View, SafeAreaView, TouchableOpacity} from 'react-native';
import { Icon } from 'react-native-elements';
import { WebView } from 'react-native-webview';
import styles from './styles';

export default function OrderingScreen() {
const payload = "https://weborders.empiredistributing.net";
const [canGoBack, setCanGoBack] = useState(false);
const [canGoForward, setCanGoForward] = useState(false);
const webviewRef = useRef(null);

        const handleBackPress = () => {
                if (webviewRef.current) {
                        webviewRef.current.goBack();
                }};

        const handleForwardPress = () => {
                if (webviewRef.current) {
                        webviewRef.current.goForward();
                }};

        const handleRefreshPress = () => {
                if (webviewRef.current) {
                        webviewRef.current.reload();
                }};

        const handleNavigationStateChange = (navState) => {
                setCanGoBack(navState.canGoBack);
                setCanGoForward(navState.canGoForward);};

return (
        <SafeAreaView
        style={styles.container}>
            {Platform.OS === 'web' ? (
                <iframe src={payload} height={"100%"} width={"100%"} frameBorder={0}/>
            ) : (
<>

                        <WebView
                            ref={webviewRef}
                            source={{ uri: 'https://weborders.empiredistributing.net' }}
                            onNavigationStateChange={handleNavigationStateChange}
                            sharedCookiesEnabled={false}
                            javaScriptEnabled={true}
                            domStorageEnabled={true}
                            startInLoadingState={true}
                        />

                        <View style={styles.navigation}>
                                <TouchableOpacity
                                    style={[styles.button, !canGoBack && styles.disabledButton]}
                                    onPress={handleBackPress}
                                    disabled={!canGoBack}>
                                        <Icon name="arrow-back" size={24} color="white" />
                                </TouchableOpacity>
                                <TouchableOpacity
                                    style={[styles.button, !canGoForward && styles.disabledButton]}
                                    onPress={handleForwardPress}
                                    disabled={!canGoForward}>
                                        <Icon name="arrow-forward" size={24} color="white" />
                                </TouchableOpacity>
                                <TouchableOpacity style={styles.button} onPress={handleRefreshPress}>
                                        <Icon name="refresh" size={24} color="white" />
                                </TouchableOpacity>
                        </View>
                        </>
            )}
        </SafeAreaView>
)
}